<template>
    <div class="container">
        <div class="content">
            <div style="display: flex;height: 32px;margin-left: 16px;padding-top: 32px;">
                <div class="title-line"></div>
                <div class="title-name">{{ titleName }}</div>
            </div>
            <div class="main1">
                <div class="panel-block flex">
                    <div class="panel-left">
                        <el-form :inline="true" :model="form" ref="form" class="form" size="small" label-width="90px"
                            :disabled="isLook" :rules="rules" label-position="right">
                            <div class="panel-item anchor-item" ref="anchor-0">
                                <div class="panel-item-title panel-item-title-1">基础信息</div>
                                <div class="panel-item-content">
                                        <el-form-item label="招聘信息来源" prop="recruitOrigin" class="label-star">
                                            <template #label>
                                                <div class="custom-label">招聘信息<br/>来源</div>
                                            </template>
                                            <el-select v-model="form.recruitOrigin" placeholder="请选择" clearable>
                                                <el-option v-for="item in dictionaries.recruit_origin"
                                                    :key="item.dictId" :label="item.dictName" :value="item.dictId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="应聘部门" prop="orgCode">
                                            <el-select v-model="form.orgCode" placeholder="请选择" clearable
                                                @change="changePosition($event)">
                                                <el-option v-for="item in positions" :key="item.orgCode"
                                                    :label="item.orgName" :value="item.orgCode">
                                                </el-option>
                                            </el-select>
                                            <!-- <el-cascader @change="handleSelectOrgId" v-model="form.orgCode"
                                                :options="options" :show-all-levels="false" :props="{
                                                    checkStrictly: true,
                                                    label: 'orgName',
                                                    value: 'orgCode',
                                                    children: 'children',
                                                }" clearable filterable></el-cascader> -->
                                        </el-form-item>
                                        <el-form-item label="应聘职位" prop="recruitPost">
                                            <el-select v-model="form.recruitPost" placeholder="请选择" clearable>
                                                <el-option v-for="item in dictionaries.recruit_post"
                                                    :key="item.dictId" :label="item.dictName" :value="item.dictId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="可到岗日期" prop="availableTime">
                                            <el-date-picker v-model="form.availableTime" type="date" placeholder="请选择年/月/日">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item label="姓名" prop="name">
                                            <template #label>姓<span class="space"></span>名</template>
                                            <el-input v-model="form.name" placeholder="请输入" maxlength="8" clearable
                                                show-word-limit></el-input>
                                        </el-form-item>
                                        <el-form-item label="性别" prop="gender">
                                            <template #label>性<span class="space"></span>别</template>
                                            <el-radio-group v-model="form.gender"  class="el-input">
                                                <el-radio :label="1">男</el-radio>
                                                <el-radio :label="2">女</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                        <el-form-item label="籍贯" prop="nativePlace">
                                            <template #label>籍<span class="space"></span>贯</template>
                                            <el-input v-model="form.nativePlace" placeholder="请输入" maxlength="12" clearable
                                                show-word-limit></el-input>
                                        </el-form-item>
                                        <el-form-item label="民族" prop="nation">
                                            <template #label>民<span class="space"></span>族</template>
                                            <el-input v-model="form.nation" placeholder="请输入" maxlength="12"
                                                clearable show-word-limit></el-input>
                                        </el-form-item>
                                        <el-form-item label="身高(cm)" prop="height">
                                            <el-input v-model="form.height" placeholder="请输入" maxlength="3" clearable
                                                show-word-limit></el-input>
                                        </el-form-item>
                                        <el-form-item label="体重(kg)" prop="weight">
                                            <el-input v-model="form.weight" placeholder="请输入" maxlength="3" clearable
                                                show-word-limit></el-input>
                                        </el-form-item>
                                        <el-form-item label="属相" prop="zodiac">
                                            <template #label>属<span class="space"></span>相</template>
                                            <el-select v-model="form.zodiac" placeholder="请选择" clearable>
                                                <el-option v-for="item in dictionaries.zodiac" :key="item.dictId"
                                                    :label="item.dictName" :value="item.dictId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="最高学历" prop="educationalLevel">
                                            <el-select v-model="form.educationalLevel" placeholder="请选择" clearable>
                                                <el-option v-for="item in dictionaries.educational_level" :key="item.dictId"
                                                    :label="item.dictName" :value="item.dictId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="身份证号码" prop="idCardNumber">
                                            <el-input v-model="form.idCardNumber" placeholder="请输入" maxlength="18" clearable
                                                show-word-limit></el-input>
                                        </el-form-item>
                                        <el-form-item label="期待工资" prop="desiredSalary">
                                            <el-input v-model.number="form.desiredSalary" placeholder="请输入" maxlength="6"
                                                clearable show-word-limit></el-input>
                                        </el-form-item>
                                        <el-form-item label="爱好/专长" prop="hobby">
                                            <el-input v-model="form.hobby" placeholder="请输入" maxlength="20" clearable
                                                show-word-limit></el-input>
                                        </el-form-item>
                                        <el-form-item label="汽(机)车驾照" prop="drivingLicenseLevel" class="label-star">
                                            <template #label>
                                                <div class="custom-label">汽(机)车<br/>驾照</div>
                                            </template>
                                            <el-select v-model="form.drivingLicenseLevel" placeholder="请选择" clearable>
                                                <el-option v-for="item in dictionaries.driving_license_level"
                                                    :key="item.dictId" :label="item.dictName" :value="item.dictId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="出生日期" prop="dateOfBirth">
                                            <el-date-picker v-model="form.dateOfBirth" type="date" placeholder="请选择年/月/日">
                                            </el-date-picker>
                                        </el-form-item>
                                        <el-form-item label="联系电话" prop="phone">
                                            <el-input v-model="form.phone" placeholder="请输入" maxlength="11" clearable
                                                show-word-limit></el-input>
                                        </el-form-item>
                                        <el-form-item label="微信号" prop="wechatNumber">
                                            <el-input v-model="form.wechatNumber" placeholder="请输入" clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="邮箱地址" prop="email">
                                            <el-input v-model="form.email" placeholder="请输入" clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="政治面貌" prop="politicalAffiliation">
                                            <el-select v-model="form.politicalAffiliation" placeholder="请选择" clearable>
                                                <el-option v-for="item in dictionaries.political_affiliation"
                                                    :key="item.dictId" :label="item.dictName" :value="item.dictId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="婚姻状况" prop="maritalStatus">
                                            <el-select v-model="form.maritalStatus" placeholder="请选择" clearable>
                                                <el-option v-for="item in dictionaries.marital_status" :key="item.dictId"
                                                    :label="item.dictName" :value="item.dictId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="户口性质" prop="householdType">
                                            <el-select v-model="form.householdType" placeholder="请选择" clearable>
                                                <el-option v-for="item in dictionaries.household_type" :key="item.dictId"
                                                    :label="item.dictName" :value="item.dictId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                         <!-- <el-form-item label="户口所在地" prop="householdResidenceCode">
                                            <el-cascader :options="addressOptions" v-model="form.householdResidenceCode"
                                                @change="onChangeAddress($event, 1)" filterable clearable></el-cascader>
                                        </el-form-item> -->
                                    <div>
                                        <el-form-item label="身份证详细地址" prop="householdResidenceDetail" class="label-star-1">
                                            <template #label>
                                                <div class="custom-label">身份证<br/>详细地址</div>
                                            </template>
                                            <el-input v-model="form.householdResidenceDetail" placeholder="请输入" clearable
                                                maxlength="32" type="textarea" style="width: 204px;" rows="3"
                                                show-word-limit></el-input>
                                        </el-form-item>
                                        <!-- <el-form-item label="现居住地" prop="currentResidenceCode">
                                            <el-cascader :options="addressOptions" v-model="form.currentResidenceCode"
                                                @change="onChangeAddress($event, 2)" filterable clearable></el-cascader>
                                        </el-form-item> -->
                                        <el-form-item label="居住地详细地址" prop="currentResidenceDetail" class="label-star-1">
                                            <template #label>
                                                <div class="custom-label">居住地<br/>详细地址</div>
                                            </template>
                                            <el-input v-model="form.currentResidenceDetail" placeholder="请输入" maxlength="32"
                                                clearable type="textarea" style="width: 204px;" rows="3"
                                                show-word-limit></el-input>
                                        </el-form-item>
                                        
                                        <el-form-item label="紧急联系人姓名" prop="emergencyContactName" class="label-star">
                                            <template #label>
                                                <div class="custom-label">紧急联系人<br/>姓名</div>
                                            </template>
                                            <el-input v-model="form.emergencyContactName" placeholder="请输入" maxlength="8" clearable
                                                show-word-limit></el-input>
                                        </el-form-item>
                                        <el-form-item label="紧急联系人电话"  prop="emergencyContactPhone" class="label-star">
                                            <template #label>
                                                <div class="custom-label">紧急联系人<br/>电话</div>
                                            </template>
                                            <el-input v-model="form.emergencyContactPhone" placeholder="请输入" maxlength="11" clearable
                                                show-word-limit></el-input>
                                        </el-form-item>
                                    </div>
                                        <el-form-item label="原单位是否存在纠纷" prop="disputeFlag" class="label-star" >
                                            <template #label>
                                                <div class="custom-label">原单位是否<br/>存在纠纷</div>
                                            </template>
                                            <div class="el-input">
                                                <el-radio-group v-model="form.disputeFlag">
                                                    <el-radio :label="1">是</el-radio>
                                                    <el-radio :label="0">否</el-radio>
                                                </el-radio-group>
                                                <el-input v-if="form.disputeFlag == 1" v-model="form.dispute" clearable
                                                    placeholder="请输入" maxlength="20" type="textarea" class="dipute-textarea" rows="3" show-word-limit></el-input>
                                            </div>

                                        </el-form-item>
                                        <el-form-item label="上传近照" prop="image">
                                            <div class="el-input my-last-photo">
                                                <template v-if="isLook">
                                                    <img :src="form.image" class="img" @click="handlePictureCardPreview(form.image)" />
                                                </template>
                                                <template v-else>
                                                    <headerPicture  @getUrl="getImage($event)" :qrCodeUrl="form.image"></headerPicture>
                                                    <div class="tips">（上传图片大小在4M以内，尺寸不限，格式为jpg，png）
                                                </div>
                                                </template>
                                            </div>
                                        </el-form-item>
                                    <div class="relative">
                                        <div class="main-colume">
                                            <el-form-item label="是否有亲戚/朋友在公司" prop="kinFlag" class="label-star" label-width="96px" >
                                                <template #label>
                                                    <div class="custom-label">是否有亲戚/<br/>朋友在公司</div>
                                                </template>
                                                <el-radio-group v-model="form.kinFlag"  class="el-input">
                                                    <el-radio label="1">是</el-radio>
                                                    <el-radio label="0">否</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>
                                        <div class="primary-colume" v-if="form.kinFlag == 1">
                                            <el-form-item label="其姓名" prop="kinName">
                                                <el-input v-model="form.kinName" placeholder="请输入" maxlength="8" clearable
                                                    show-word-limit></el-input>
                                            </el-form-item>
                                            <el-form-item label="关系" prop="kinRelationship">
                                                <template #label>关<span class="space"></span>系</template>
                                                <el-input v-model="form.kinRelationship" placeholder="请输入" maxlength="8"
                                                    clearable show-word-limit></el-input>
                                            </el-form-item>
                                            <el-form-item label="部门" prop="kinOrganization">
                                                <template #label>部<span class="space"></span>门</template>
                                                <el-input v-model="form.kinOrganization" placeholder="请输入" maxlength="12"
                                                    clearable show-word-limit></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                    <div class="line"></div>
                                </div>

                            </div>
                            <div class="panel-item anchor-item" ref="anchor-1">
                                <div class="panel-item-title">工作履历<span
                                        style="font-weight: 400;font-size: 16px;color: #616363;">（时间由近至远）</span></div>
                                <div class="panel-item-content">
                                    <div v-for="(item, index) in form.workRecordList" :key="index"
                                        style="margin-bottom: 24px;">
                                        <div style="display:flex;justify-content:flex-start;align-items:center">
                                            <div class="sort-index">{{ index + 1 }}</div>
                                            <div class="sort-title">工作履历</div>
                                        </div>
                                        <div style="margin-top:26px">
                                            <div
                                                style="display:flex;justify-content:flex-start;position: relative;">
                                                <div>
                                                        <el-form-item label="起始日期"
                                                            :prop="'workRecordList.' + index + '.startTime'"
                                                            :rules="[{ required: true, message: '请选择起始日期', trigger: 'change' }]">
                                                            <el-date-picker v-model="item.startTime" type="date"
                                                                placeholder="请选择年/月/日">
                                                            </el-date-picker>
                                                        </el-form-item>
                                                        <el-form-item label="结束日期"
                                                            :prop="'workRecordList.' + index + '.endTime'"
                                                            :rules="[{ required: true, message: '请选择结束日期', trigger: 'change' }]">
                                                            <el-date-picker v-model="item.endTime" type="date"
                                                                placeholder="请选择年/月/日">
                                                            </el-date-picker>
                                                        </el-form-item>
                                                        <el-form-item label="单位名称"
                                                            :prop="'workRecordList.' + index + '.company'"
                                                            :rules="[{ required: true, message: '请输入单位名称', trigger: 'blur' }]">
                                                            <el-input v-model="item.company" placeholder="请输入"
                                                                clearable maxlength="24"></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="任职部门"
                                                            :prop="'workRecordList.' + index + '.organization'"
                                                            :rules="[{ required: true, message: '请输入任职部门', trigger: 'blur' }]">
                                                            <el-input v-model="item.organization" placeholder="请输入"
                                                                clearable maxlength="12" show-word-limit></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="担任职位"
                                                            :prop="'workRecordList.' + index + '.post'"
                                                            :rules="[{ required: true, message: '请输入担任职位', trigger: 'blur' }]">
                                                            <el-input v-model="item.post" placeholder="请输入"
                                                                clearable></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="现离职原因"
                                                            :prop="'workRecordList.' + index + '.resignationReason'"
                                                            :rules="[{ required: true, message: '请选择现离职原因', trigger: 'change' }]">
                                                            <el-select v-model="item.resignationReason" placeholder="请选择"
                                                                clearable>
                                                                <el-option v-for="itm in dictionaries.resignation_reason"
                                                                    :key="itm.dictId" :label="itm.dictName"
                                                                    :value="itm.dictId">
                                                                </el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                        <el-form-item label="月薪"
                                                            :prop="'workRecordList.' + index + '.salary'"
                                                            :rules="[{ required: true, message: '请输入月薪', trigger: 'blur' }]">
                                                            <template #label>月<span class="space"></span>薪</template>
                                                            <el-input v-model="item.salary" placeholder="请输入"
                                                                clearable></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="证明人"
                                                            :prop="'workRecordList.' + index + '.certifier'"
                                                            :rules="[{ required: true, message: '请输入证明人', trigger: 'blur' }]">
                                                            <el-input v-model="item.certifier" placeholder="请输入" clearable
                                                                maxlength="8" show-word-limit></el-input>
                                                        </el-form-item>

                                                        <el-form-item label="联系电话"
                                                            :prop="'workRecordList.' + index + '.phone'"
                                                            :rules="[{ required: true, message: '请输入联系电话', trigger: 'blur' }]">
                                                            <el-input v-model="item.phone" placeholder="请输入" maxlength="11"
                                                                clearable show-word-limit></el-input>
                                                        </el-form-item>
                                                </div>
                                                <div class="delete" @click="deletePlus(1, index)"
                                                    v-if="!isLook && index != 0">
                                                    删除</div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="btn" @click="addPlus(1)" v-if="!isLook">
                                        <div style="display:flex;justify-content:center;align-items:center">
                                            <div>
                                                <i class="el-icon-plus" style="color:#00B498"></i>
                                            </div>

                                            <div class="btn-t">添加工作履历</div>
                                        </div>
                                    </div>
                                    <div class="line"></div>
                                </div>
                            </div>
                            <div class="panel-item anchor-item" ref="anchor-2">
                                <div class="panel-item-title">教育经历<span
                                        style="font-weight: 400;font-size: 16px;color: #616363;">（学历由高至低）</span></div>
                                <div class="panel-item-content">
                                    <div v-for="(item, index) in form.educationList" :key="index"
                                        style="margin-bottom: 24px;">
                                        <div style="display:flex;justify-content:flex-start;align-items:center">
                                            <div class="sort-index">{{ index + 1 }}</div>
                                            <div class="sort-title">教育经历</div>
                                        </div>
                                        <div style="margin-top:26px">
                                            <div
                                                style="display:flex;height:auto;justify-content: space-between;position: relative;">
                                                <div>
                                                    <div class="form-item" style="justify-content: flex-start;">
                                                        <el-form-item label="起始日期"
                                                            :prop="'educationList.' + index + '.startTime'"
                                                            :rules="[{ required: true, message: '请选择起始日期', trigger: 'change' }]">
                                                            <el-date-picker v-model="item.startTime" type="date"
                                                                placeholder="请选择年/月/日">
                                                            </el-date-picker>
                                                        </el-form-item>
                                                        <el-form-item label="结束日期"
                                                            :prop="'educationList.' + index + '.endTime'"
                                                            :rules="[{ required: true, message: '请选择结束日期', trigger: 'change' }]">
                                                            <el-date-picker v-model="item.endTime" type="date"
                                                                placeholder="请选择年/月/日">
                                                            </el-date-picker>
                                                        </el-form-item>
                                                        <el-form-item label="学校名称"
                                                            :prop="'educationList.' + index + '.institutionName'"
                                                            :rules="[{ required: true, message: '请输入学校名称', trigger: 'blur' }]">
                                                            <el-input v-model="item.institutionName" clearable
                                                                placeholder="请输入"></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="专业"                                                             :prop="'educationList.' + index + '.major'"
                                                            :rules="[{ required: true, message: '请输入专业', trigger: 'blur' }]">
                                                            <template #label>专<span class="space"></span>业</template>
                                                            <el-input v-model="item.major" placeholder="请输入" maxlength="12"
                                                                clearable show-word-limit></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="学历"
                                                            :prop="'educationList.' + index + '.educationalLevel'"
                                                            :rules="[{ required: true, message: '请选择学历', trigger: 'change' }]">
                                                            <template #label>学<span class="space"></span>历</template>
                                                            <el-select v-model="item.educationalLevel" placeholder="请选择"
                                                                clearable>
                                                                <el-option v-for="itm in dictionaries.educational_level"
                                                                    :key="itm.dictId" :label="itm.dictName"
                                                                    :value="itm.dictId">
                                                                </el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                        <el-form-item label="教育类型"
                                                            :prop="'educationList.' + index + '.educationalMode'"
                                                            :rules="[{ required: true, message: '请选择教育类型', trigger: 'change' }]">
                                                            <el-select v-model="item.educationalMode" placeholder="请选择"
                                                                clearable>
                                                                <el-option v-for="itm in dictionaries.educational_mode"
                                                                    :key="itm.dictId" :label="itm.dictName"
                                                                    :value="itm.dictId">
                                                                </el-option>
                                                            </el-select>
                                                        </el-form-item>


                                                    </div>
                                                </div>
                                                <div class="delete" @click="deletePlus(2, index)"
                                                    v-if="!isLook && index != 0">
                                                    删除</div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="btn" @click="addPlus(2)" v-if="!isLook">
                                        <div style="display:flex;justify-content:center;align-items:center">
                                            <div>
                                                <i class="el-icon-plus" style="color:#00B498"></i>
                                            </div>

                                            <div class="btn-t">添加教育经历</div>
                                        </div>
                                    </div>
                                    <div class="line"></div>
                                </div>
                            </div>
                            <div class="panel-item anchor-item" ref="anchor-3">
                                <div class="panel-item-title">家庭信息</div>
                                <div class="panel-item-content">
                                    <div v-for="(item, index) in form.familyInfoList" :key="index"
                                        style="margin-bottom: 24px;">
                                        <div style="display:flex;justify-content:flex-start;align-items:center">
                                            <div class="sort-index">{{ index + 1 }}</div>
                                            <div class="sort-title">家庭成员</div>
                                        </div>
                                        <div style="margin-top:26px">
                                            <div
                                                style="display:flex;height:auto;justify-content: space-between;position: relative;">
                                                <div>
                                                    <div class="form-item">
                                                        <el-form-item label="本人关系"
                                                            :prop="'familyInfoList.' + index + '.familyRelationships'"
                                                            :rules="[{ required: true, message: '请选择学历', trigger: 'change' }]">
                                                            <el-select v-model="item.familyRelationships" placeholder="请选择"
                                                                clearable>
                                                                <el-option v-for="itm in dictionaries.family_relationships"
                                                                    :key="itm.dictId" :label="itm.dictName"
                                                                    :value="itm.dictId">
                                                                </el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                        <el-form-item label="姓名"
                                                            :prop="'familyInfoList.' + index + '.name'"
                                                            :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]">
                                                            <template #label>姓<span class="space"></span>名</template>
                                                            <el-input v-model="item.name" placeholder="请输入"
                                                                clearable></el-input>
                                                        </el-form-item>
                                                        <!-- <el-form-item label="是否为紧急联系人（至少一位）"
                                                            style="width: 25%;margin-right: 0;min-width: 330px;"
                                                            :prop="'familyInfoList.' + index + '.emergencyFlag'"
                                                            :rules="[{ required: true, message: '请选择是否紧急联系人', trigger: 'change' }]"
                                                            label-width="124px" >
                                                            <el-radio-group v-model="item.emergencyFlag"
                                                                style="width: 180px;">
                                                                <el-radio :label="1">是</el-radio>
                                                                <el-radio :label="0">否</el-radio>
                                                            </el-radio-group>
                                                        </el-form-item> -->
                                                        <!-- <el-form-item label="出生日期"
                                                            style="width: 25%;margin-right: 0;min-width: 330px;"
                                                            :prop="'familyInfoList.' + index + '.dateOfBirth'"
                                                            :rules="[{ required: true, message: '请选择是出生日期', trigger: 'change' }]">
                                                            <el-date-picker v-model="item.dateOfBirth" type="date"
                                                                placeholder="请选择年/月/日">
                                                            </el-date-picker>
                                                        </el-form-item> -->
                                                    <!-- </div>
                                                    <div class="form-item"> -->
                                                        <el-form-item label="工作单位"
                                                            :prop="'familyInfoList.' + index + '.company'"
                                                            :rules="[{ required: true, message: '请输入工作单位', trigger: 'blur' }]">
                                                            <el-input v-model="item.company" placeholder="请输入" clearable
                                                                maxlength="20" show-word-limit></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="职务"
                                                            :prop="'familyInfoList.' + index + '.post'"
                                                            :rules="[{ required: true, message: '请输入职务', trigger: 'blur' }]">
                                                            <template #label>职<span class="space"></span>务</template>
                                                            <el-input v-model="item.post" placeholder="请输入" maxlength="8"
                                                                clearable show-word-limit></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="联系电话"
                                                            :prop="'familyInfoList.' + index + '.phone'"
                                                            :rules="[{ required: true, message: '请输入联系电话', trigger: 'blur' }]">
                                                            <el-input v-model="item.phone" placeholder="请输入" maxlength="11"
                                                                clearable show-word-limit></el-input>
                                                        </el-form-item>


                                                    </div>
                                                </div>
                                                <div class="delete" @click="deletePlus(3, index)"
                                                    v-if="!isLook && index != 0">
                                                    删除</div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="btn" @click="addPlus(3)" v-if="!isLook">
                                        <div style="display:flex;justify-content:center;align-items:center">
                                            <div>
                                                <i class="el-icon-plus" style="color:#00B498"></i>
                                            </div>

                                            <div class="btn-t">添加家庭成员</div>
                                        </div>
                                    </div>
                                    <div class="line"></div>
                                </div>
                            </div>
                            <div class="panel-item anchor-item" ref="anchor-4">
                                <div class="panel-item-title">培训经历<span
                                        style="font-weight: 400;font-size: 16px;color: #616363;">（非必填项）</span></div>
                                <div class="panel-item-content">
                                    <div v-for="(item, index) in form.trainingInfoList" :key="index"
                                        style="margin-bottom: 24px;">
                                        <div style="display:flex;justify-content:flex-start;align-items:center">
                                            <div class="sort-index">{{ index + 1 }}</div>
                                            <div class="sort-title">培训经历</div>
                                        </div>
                                        <div style="margin-top:26px">
                                            <div style="display:flex;height:auto;justify-content: space-between;position: relative;">
                                                <div>
                                                          <el-form-item label="起始日期"
                                                            :prop="'trainingInfoList.' + index + '.startTime'"
                                                            :rules="[{ required: false, message: '', trigger: 'blur' }]">
                                                            <el-date-picker v-model="item.startTime" type="date"
                                                                placeholder="请选择年/月/日">
                                                            </el-date-picker>
                                                        </el-form-item>
                                                        <el-form-item label="结束日期"
                                                            :prop="'trainingInfoList.' + index + '.endTime'"
                                                            :rules="[{ required: false, message: '', trigger: 'blur' }]">
                                                            <el-date-picker v-model="item.endTime" type="date"
                                                                placeholder="请选择年/月/日">
                                                            </el-date-picker>
                                                        </el-form-item>
                                                        <el-form-item label="培训方式"
                                                            :prop="'trainingInfoList.' + index + '.trainingMode'"
                                                            :rules="[{ required: false, message: '', trigger: 'blur' }]">
                                                            <el-select v-model="item.trainingMode" placeholder="请选择"
                                                                clearable>
                                                                <el-option v-for="itm in dictionaries.training_mode"
                                                                    :key="itm.dictId" :label="itm.dictName"
                                                                    :value="itm.dictId">
                                                                </el-option>
                                                            </el-select>
                                                        </el-form-item>
                                                        <el-form-item label="培训机构"
                                                            :prop="'trainingInfoList.' + index + '.institutionName'"
                                                            :rules="[{ required: false, message: '', trigger: 'blur' }]">
                                                            <el-input v-model="item.institutionName" placeholder="请输入"
                                                                clearable maxlength="16" show-word-limit></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="获取证书"
                                                            :prop="'trainingInfoList.' + index + '.certificate'"
                                                            :rules="[{ required: false, message: '', trigger: 'blur' }]">
                                                            <!-- <el-input v-model="item.certificate" placeholder="请输入" clearable
                                                                maxlength="20" show-word-limit></el-input> -->
                                                            <el-input v-model="item.certificate" type="textarea"
                                                            clearable placeholder="请输入" size="medium" rows="3"
                                                            maxlength="16"
                                                            show-word-limit></el-input>
                                                        </el-form-item>
                                                        <el-form-item label="培训内容"
                                                            :prop="'trainingInfoList.' + index + '.trainingContent'"
                                                            :rules="[{ required: false, message: '', trigger: 'blur' }]">
                                                            <!-- <el-input v-model="item.trainingContent" type="textarea"
                                                                clearable placeholder="请输入" size="medium" rows="2"
                                                                style="width:535px;height:64px" maxlength="64"
                                                                show-word-limit></el-input> -->
                                                            <el-input v-model="item.trainingContent" type="textarea"
                                                            clearable placeholder="请输入" size="medium" rows="3"
                                                            maxlength="64"
                                                            show-word-limit></el-input>
                                                        </el-form-item>
                                                </div>
                                                <div class="delete" @click="deletePlus(4, index)"
                                                    v-if="!isLook && index != 0">
                                                    删除</div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="btn" @click="addPlus(4)" v-if="!isLook">
                                        <div style="display:flex;justify-content:center;align-items:center">
                                            <div>
                                                <i class="el-icon-plus" style="color:#00B498"></i>
                                            </div>

                                            <div class="btn-t">添加培训经历</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                        <div style="height:40px"></div>
                    </div>
                    <transition name="el-fade-in">
                        <div class="panel-right" v-show="footer">
                            <el-tabs tab-position="right" v-model="activeBtn" @tab-click="handleClickAchors"
                                class="vertical-tabs" style="height: auto;">
                                <el-tab-pane v-for="(item, index) in anchors" :key="index" :label="item.label"
                                    :name="String(index)"></el-tab-pane>
                            </el-tabs>
                        </div>
                    </transition>
                </div>
            </div>

        </div>
        <transition name="el-fade-in">
            <div class="footer" v-show="footer" :class="[isCollapsed?'footer-collapsed':'']">
                <div class="footer-btn-b" @click="back()">返回</div>
                <div class="footer-btn-r" v-if="!isLook" @click="reset()">重置</div>
                <div class="footer-btn-s" v-if="!isLook" @click="save">确认</div>
            </div>
        </transition>
        <!--关联 -->
        <el-dialog title="关联应聘信息" :visible.sync="isRelative" width="978px" append-to-body>
            <div class="dialog-body">
                <div class="dialog-title">
                    <el-form :inline="true" :model="form" ref="form" class="form" size="small" label-width="82px"
                        style="width:300px" :rules="rules">
                        <el-form-item label="应聘信息联系电话">
                            <template #label>
                                <div style="line-height: 18px;"><span
                                        style="color: #F56C6C;margin-right: 4px;">*</span>应聘信息联系电话
                                </div>
                            </template>
                            <el-input v-model="form.name" placeholder="请输入" maxlength="11" show-word-limit
                                style="width:204px"></el-input>
                        </el-form-item>
                    </el-form>
                    <div style="width:60px">
                        <el-button type="primary" @click="fetchData('search')" size="small">查询</el-button>
                    </div>
                </div>
                <div class="dialog-line"></div>
                <div class="dialog-content">
                    <div style="display: flex;height: 32px;">
                        <div class="title-line"></div>
                        <div class="title-name">查询结果</div>
                    </div>
                    <div class="dialog-main">
                        <!-- <div class="dialog-main-no">暂无可关联信息</div> -->
                        <div class="dialog-list">
                            <!-- <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list"
                                @selection-change="onMultipleSelection">
                            </lb-table> -->

                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isRelative = false">取 消</el-button>
                <el-button type="primary" @click="isRelative = false">关联</el-button>
            </span>
        </el-dialog>
        <!--取消关联 -->
        <el-dialog title="取消关联" :visible.sync="isNoRelative" width="552px" append-to-body>
            <div class="dialog-body">
                <div class="dialog-title">
                    <el-form :inline="true" :model="form" ref="form" class="form" size="small" label-width="100px"
                        style="margin-left:55px" :rules="rules">
                        <el-form-item label="登录手机号">
                            <template #label>
                                <div style="line-height: 32px;"><span
                                        style="color: #F56C6C;margin-right: 4px;">*</span>登录手机号
                                </div>
                            </template>
                            <el-input v-model="form.name" placeholder="请输入" maxlength="11" show-word-limit
                                style="width:204px"></el-input>
                        </el-form-item>
                    </el-form>
                    <div>
                        <div style="display: flex;justify-content:space-between;">
                            <img src="../../../assets/icon_guanlian.png"
                                style="width: 16px;height: 16px;padding-top:8px;padding-right:2px" />
                            <div style="line-height: 32px;font-size: 14px;color: #00B498;" @click="isConfirm = true">取消关联
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!--确认 -->
        <el-dialog title="提示" :visible.sync="isConfirm" width="268px" append-to-body>
            <span
                style="font-size: 14px;color: #2F3030;line-height: 22px;text-align: center;margin-left:12px">是否确认取消关联应聘信息？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isConfirm = false">取 消</el-button>
                <el-button type="primary" @click="isConfirm = false">确认</el-button>
            </span>
        </el-dialog>
        <!-- 预览图片 -->
        <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" fit="contain" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>
  
<script>
import addressData from '@/components/addressData.js'
import headerPicture from '../../../components/headerPicture.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
    name: 'addStaff',
    components: {
        headerPicture,
        LbTable
    },
    props: {
        pageActive: {
        type: String,
        required: false, // 可选
        default: '0'     // 默认值
        }
    },
    data() {
        return {
            titleName: '新增应聘信息',
            positions: [],
            tags: [
                {
                    label: '员工信息',
                    name: '1'
                },
                {
                    label: '角色权限',
                    name: '2'
                }
            ],
            anchors: [
                {
                    label: '基础信息',
                    name: '1'
                },
                {
                    label: '工作履历',
                    name: '2'
                },
                {
                    label: '教育经历',
                    name: '3'
                },
                {
                    label: '家庭信息',
                    name: '4'
                },
                {
                    label: '培训经历',
                    name: '5'
                }
            ],
            activeName: '1',
            activeBtn: '0', //锚点按钮
            stepData: ['区域1', '区域2', '区域3', '区域4'],
            contentDiv: null, //锚点区域
            isGo: false, //是否滚动
            form: {
                name: '',
                gender: null,
                recruitType: null,
                orgCode: '',
                orgName: '',
                recruitPost: null,
                availableTime: null,
                recruitOrigin: null,
                nativePlace: '',
                nation:'',
                height: '',
                weight: '',
                zodiac: null,
                educationalLevel:'',
                educationalType: null,
                idCardNumber: '',
                desiredSalary: '',
                hobby: '',
                drivingLicenseLevel: null,
                dateOfBirth: '',
                phone: '',
                wechatNumber: '',
                email: '',
                kinName: '',
                kinRelationship: '',
                kinOrganization: '',
                politicalAffiliation: null,
                maritalStatus: null,
                householdType: null,
                householdResidence: '',
                householdResidenceCode: [],
                householdResidenceDetail: '',
                currentResidence: '',
                currentResidenceCode: [],
                currentResidenceDetail: '',
                image: '',
                dispute: '',
                disputeFlag: null,
                emergencyContactName:'',
                emergencyContactPhone:'',
                kinFlag:'',
                kinName:'',
                kinRelationship:'',
                kinOrganization:'',
                workRecordList: [
                    {
                        post: null,
                        phone: '',
                        company: '',
                        organization: '',
                        resignationReason: '',
                        resignationReasonLabel: '',
                        salary: '',
                        certifier: '',
                        startTime: '',
                        endTime: ''
                    }
                ],
                educationList: [
                    {
                        educationalLevel: null,
                        educationalLevelLabel: '',
                        institutionName: '',
                        major: '',
                        educationalMode: null,
                        educationalModeLabel: '',
                        startTime: '',
                        endTime: '',
                    }
                ],
                familyInfoList: [
                    {
                        name: '',
                        dateOfBirth: '',
                        company: '',
                        post: '',
                        phone: '',
                        familyRelationships: null,
                        familyRelationshipsLabel: '',
                        emergencyFlag: null
                    }
                ],
                trainingInfoList: [
                    {
                        institutionName: '',
                        trainingContent: '',
                        trainingMode: null,
                        trainingModeLabel: '',
                        certificate: '',
                        startTime: '',
                        endTime: ''

                    }
                ],

            },
            rules: {

                recruitType: [
                    { required: true, message: '请选择招聘方式', trigger: 'change' }
                ],
                orgCode: [
                    { required: true, message: '请选择应聘部门', trigger: 'change' },
                ],
                recruitPost: [
                    { required: true, message: '请选择应聘职位', trigger: 'change' },
                ],
                recruitOrigin: [
                    { required: true, message: '请选择简历投递渠道', trigger: 'change' },
                ],
                nation: [
                    { required: true, message: '请输入民族', trigger: 'blur' }
                ],
                availableTime: [
                    { required: true, message: '请选择可到岗时间', trigger: 'change' }
                ],
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                gender: [
                    { required: true, message: '请选择性别', trigger: 'change' }
                ],
                nativePlace: [
                    { required: true, message: '请输入籍贯', trigger: 'blur' }
                ],
                height: [
                    { required: true, message: '请输入身高', trigger: 'blur' }
                ],
                weight: [
                    { required: true, message: '请输入体重', trigger: 'blur' }
                ],
                zodiac: [
                    { required: true, message: '请选择属相', trigger: 'change' }
                ],
                educationalLevel: [
                    { required: true, message: '请选择最高学历', trigger: 'change' }
                ],
                idCardNumber: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' }
                ],
                desiredSalary: [
                    { required: true, message: '请输入期待工资', trigger: 'blur' }
                ],
                hobby: [
                    { required: true, message: '请输入爱好/专长', trigger: 'blur' }
                ],
                drivingLicenseLevel: [
                    { required: true, message: '请选择汽（机）车驾照', trigger: 'change' }
                ],
                dateOfBirth: [
                    { required: true, message: '请选择出生日期', trigger: 'change' }
                ],
                phone: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' }
                ],
                wechatNumber: [
                    { required: true, message: '请输入微信号', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' }
                ],
                politicalAffiliation: [
                    { required: true, message: '请选择政治面貌', trigger: 'change' }
                ],
                maritalStatus: [
                    { required: true, message: '请选择婚姻状况', trigger: 'change' }
                ],
                householdType: [
                    { required: true, message: '请选择户口性质', trigger: 'change' }
                ],
                householdResidenceCode: [
                    { required: true, message: '请选择户口所在地', trigger: 'change' }
                ],
                householdResidenceDetail: [
                    { required: true, message: '请输入户口所在地详细地址', trigger: 'blur' }
                ],
                currentResidenceCode: [
                    { required: true, message: '请选择现居住地', trigger: 'change' }
                ],
                currentResidenceDetail: [
                    { required: true, message: '请输入现居住地详细地址', trigger: 'blur' }
                ],
                image: [
                    { required: true, message: '请上传近照', trigger: 'change' }
                ],
                emergencyContactName: [
                    { required: true, message: '请输入紧急联系人姓名', trigger: 'blur' }
                ],
                emergencyContactPhone: [
                    { required: true, message: '请输入紧急联系人电话', trigger: 'blur' }
                ],
                disputeFlag: [
                    { required: true, message: '请选择是否存在纠纷', trigger: 'change' }
                ],
                kinFlag: [
                    { required: true, message: '请选择是否有亲戚/朋友在公司', trigger: 'change' }
                ],
                kinName: [
                    { required: true, message: '请输入亲戚/朋友姓名', trigger: 'blur' }
                ],
                kinRelationship: [
                    { required: true, message: '请输入亲戚/朋友关系', trigger: 'blur' }
                ],
                kinOrganization: [
                    { required: true, message: '请输入亲戚/朋友所在部门', trigger: 'blur' }
                ]

            },
            isRelative: false,
            isNoRelative: false,
            isConfirm: false,
            list: [
                {

                },
                {}
            ],
            columns: [
                { type: 'selection', minWidth: '80', fixed: 'left' },
                { label: '应聘日期', prop: 'serial', },
                { label: '应聘者姓名', prop: 'username', },
                { label: '性别', prop: 'username', },
                { label: '应聘部门', prop: 'phoneNumber', },
                { label: '应聘岗位', prop: 'phoneNumber', },
                { label: '应聘状态', prop: 'phoneNumber', },
                { label: '是否已关联员工', prop: 'phoneNumber', minWidth: '140' },
                { label: '备注', prop: 'phoneNumber', },
            ],
            options: [],
            positionList: [],
            timeout: null,
            dictionaries: {},
            roleDataList: [],
            isLook: false,
            dialogVisible: false,
            dialogImageUrl: '',
            footer:true

        }
    },
    computed: { 
        isCollapsed() {
            return this.$store.state.isCollapsed
        }
    },
    created() {
        // console.log(111)
        this.dictionaries = this.fmObjToArr(JSON.parse(sessionStorage.getItem('dictionaries')))
        // console.log(this.dictionaries)
        this.department()
        this.getPositionList()
        this.getPosition()
        // console.log(this.dict('job_nature'))
        this.dict('recruit_post')
        this.dict('recruit_origin')
        this.dict('job_nature')
        this.dict('recruit_type')
        this.dict('zodiac')
        this.dict('educational_type')
        this.dict('marital_status')
        this.dict('driving_license_level')
        this.dict('political_affiliation')
        this.dict('household_type')
        this.dict('resignation_reason')
        this.dict('educational_mode')
        this.dict('educational_level')
        this.dict('family_relationships')
        this.dict('training_mode')
        this.trimAddressData()
        this.getRoleList()
        this.activeBtn = '0'
        
    },
    activated() {
        if (this.$route.query.id) {
            this.getDetail(this.$route.query.id)
            // this.dataList[2].name = "查看应聘信息"
            this.titleName = "查看应聘信息"
            this.isLook = true
        }else{
            this.titleName = "新增应聘信息"
            this.isLook = false
            this.$nextTick(()=>{
                this.reset()
                this.footer = true
            })
        }
    },
    watch: {
      pageActive(newValue, oldValue) {
        if (!this.isGo && this.activeBtn != newValue) {
            this.activeBtn = newValue
            console.log('addApplication>>',this.activeBtn)
         }
      },
    },
    methods: {
        // 预览图片
        handlePictureCardPreview(url) {
            this.dialogImageUrl = url
            this.dialogVisible = true
            console.log('>>',url)
        },
        getDetail(id) {
            let ids = []
            ids.push(id)
            let data = {
                ids: ids
            }
            this.axios.post('/oa/sys/applicant/detail/list', data).then((res) => {
                if (res.code == 0) {
                    res.data = res.data[0]
                    res.data.jobNature = String(res.data.jobNature)
                    res.data.recruitPost = String(res.data.recruitPost)
                    res.data.recruitOrigin = String(res.data.recruitOrigin)
                    res.data.recruitType = String(res.data.recruitType)
                    res.data.educationalLevel = String(res.data.educationalLevel)
                    res.data.zodiac = String(res.data.zodiac)
                    res.data.drivingLicenseLevel = String(res.data.drivingLicenseLevel)
                    res.data.politicalAffiliation = String(res.data.politicalAffiliation)
                    res.data.maritalStatus = String(res.data.maritalStatus)
                    res.data.householdType = String(res.data.householdType)
                    res.data.educationalType = String(res.data.educationalType)
                    res.data.kinFlag = String(res.data.kinFlag)
                    res.data.orgCode = res.data.orgName
                    if (res.data.workRecordList) {
                        res.data.workRecordList.forEach(item => {
                            item.resignationReason = String(item.resignationReason)
                            item.educationalMode = String(item.educationalMode)
                        })
                    }
                    if (res.data.educationList) {
                        res.data.educationList.forEach(item => {
                            item.educationalLevel = String(item.educationalLevel)
                            item.educationalMode = String(item.educationalMode)
                        })

                    }
                    if (res.data.familyInfoList) {
                        res.data.familyInfoList.forEach(item => {
                            item.familyRelationships = String(item.familyRelationships)
                        })
                    }
                    if (res.data.trainingInfoList) {
                        res.data.trainingInfoList.forEach(item => {
                            item.trainingMode = String(item.trainingMode)
                        })
                    }
                    if (res.data.householdResidenceCode) {
                        let arr = []
                        res.data.householdResidenceCode.forEach(item => {
                            arr.push(Number(item))
                        })
                        console.log(arr)
                        res.data.householdResidenceCode = arr
                    }
                    if (res.data.currentResidenceCode) {
                        let arr = []
                        res.data.currentResidenceCode.forEach(item => {
                            arr.push(Number(item))
                        })
                        console.log(arr)
                        res.data.currentResidenceCode = arr
                    }
                    this.form = res.data
                } else {
                    this.$message.error(res.message)
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        changePosition(val) {
            console.log(val)
            this.positions.forEach(item => {
                if (item.orgCode == val) {
                    this.form.orgName = item.orgName
                }
            })
        },
        addPlus(val) {
            if (val == 1) {
                let obj = {
                    post: null,
                    phone: '',
                    company: '',
                    organization: '',
                    resignationReason: '',
                    resignationReasonLabel: '',
                    salary: '',
                    certifier: '',
                    startTime: '',
                    endTime: ''
                }
                this.form.workRecordList.push(obj)
            } else if (val == 2) {
                let obj = {
                    educationalLevel: null,
                    educationalLevelLabel: '',
                    institutionName: '',
                    major: '',
                    educationalMode: null,
                    educationalModeLabel: '',
                    startTime: '',
                    endTime: '',
                }
                this.form.educationList.push(obj)
            } else if (val == 3) {
                let obj = {
                    name: '',
                    dateOfBirth: '',
                    company: '',
                    post: '',
                    phone: '',
                    familyRelationships: null,
                    familyRelationshipsLabel: '',
                    emergencyFlag: null
                }
                this.form.familyInfoList.push(obj)

            } else if (val == 4) {
                let obj = {
                    institutionName: '',
                    trainingContent: '',
                    trainingMode: null,
                    trainingModeLabel: '',
                    certificate: '',
                    startTime: '',
                    endTime: ''

                }
                this.form.trainingInfoList.push(obj)
            }

        },
        deletePlus(val, index) {
            if (val == 1) {
                this.form.workRecordList.splice(index, 1)
            } else if (val == 2) {
                this.form.educationList.splice(index, 1)
            } else if (val == 3) {
                this.form.familyInfoList.splice(index, 1)
            } else if (val == 4) {
                this.form.trainingInfoList.splice(index, 1)
            }

        },
        back() {
            this.$router.go(-1)
        },
        reset() {
            this.$nextTick(()=>{
                this.$refs.form.clearValidate()
                this.$refs.form.resetFields()
            })
        },
        getEmptyProperties(obj) {
            let emptyProperties = [];
            Object.keys(obj).forEach(key => {
                if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
                    emptyProperties.push(key);
                }
            });
            return emptyProperties;
        },
        save() {
            // this.form.orgCode = this.form.orgCode[this.form.orgCode.length - 1]
            this.form.trainingInfoList = this.form.trainingInfoList.filter(item => this.getEmptyProperties(item).length != 7)
            let params = {}
            params = Object.assign(params, this.form)
            if (Array.isArray(this.form.orgCode)) {
                params.orgCode = this.form.orgCode[this.form.orgCode.length - 1]
            } else {
                params.orgCode = this.form.orgCode
            }
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.axios.post('/oa/sys/applicant', params).then((res) => {
                        if (res.code == 0) {
                            this.$message({ message: '提交成功', type: 'success' })
                            this.reset()
                            this.$router.push({ path: '/hireManagement/application' })
                        } else {
                            this.$message.error(res.message)
                        }
                    })

                } else {
                    return false
                }
            })
        },
        // 角色下拉列表数据
        getRoleList() {
            const data = {
                pageNo: 1,
                pageSize: 10000
            }
            this.$api.rolePageList(data).then(res => {
                // console.log(res)
                if (res.code == 0) {
                    this.roleDataList = res.data.list
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        // 初始化地区数据
        trimAddressData() {
            // console.log("初始化地区数据", addressData)
            const arr = []
            for (const province in addressData) {
                const childrenCity = []
                for (const city in addressData[province]) {
                    const childrenArea = []
                    addressData[province][city].forEach((e, i) => {
                        childrenArea.push({ title: '市区', label: e, value: i })
                    })
                    childrenCity.push({ title: '城市', label: city, children: childrenArea, value: city })
                    // console.log(childrenCity.children)
                }
                arr.push({ title: '省份', label: province, children: childrenCity, value: province })
            }
            // 修改 value 值
            arr.forEach((e, i) => {
                e.value = i
                e.children.forEach((ee, ii) => {
                    ee.value = ii
                })
            })
            this.addressOptions = arr
        },
        // 地区修改
        onChangeAddress(val, type) {
            console.log(val)
            const addressOptions = this.addressOptions
            let province = ''
            let city = ''
            let region = ''
            for (let i = 0; i < val.length; i++) {
                if (i === 0) {
                    province = addressOptions[val[0]].label
                    console.log('省份', province)
                    continue
                }
                if (i === 1) {
                    city = addressOptions[val[0]].children[val[1]].label
                    console.log('城市', city)
                    continue
                }
                if (i === 2) {
                    region = addressOptions[val[0]].children[val[1]].children[val[2]].label
                    console.log('市区', region)
                    continue
                }
            }
            if (type == 1) {
                this.form.householdResidence = province + city + region
                console.log(this.form.householdResidence)
            } else {
                this.form.currentResidence = province + city + region
            }

        },
        getImage(val) {
            this.form.image = val
            this.$refs.form.validateField('image')

        },
        dict(val) {
            this.dictionaries.forEach((item) => {
                // console.log(item)
                if (item.value == val) {
                    this.dictionaries[val] = item.label
                }
            })
        },
        fmObjToArr(data) {
            let arr = []
            for (let key in data) {
                let tem = []
                for (let i in data[key]) {
                    let obj = {
                        dictId: i,
                        dictName: data[key][i]

                    }
                    tem.push(obj)
                }
                arr.push({
                    label: tem, // label 字段
                    value: key   // value字段
                })
            }
            // console.log(arr)
            return arr
        },
        querySearch1(queryString, cb) {
            this.axios
                .get('/oa/sys/employee/superior/' + this.form.directSuperior)
                .then((res) => {
                    console.log(res)
                    if (res.code == 0) {
                        res.data.forEach((item) => {
                            item.value = item.name
                        })

                        var results = queryString ? res.data : [];
                        // 调用 callback 返回建议列表的数据
                        clearTimeout(this.timeout);
                        this.timeout = setTimeout(() => {
                            cb(results);
                        }, 3000 * Math.random());
                        // cb(results);
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        handleSelect1(item) {
            this.form.directSuperior = item.name

        },
        handleSelectOrgId(e) {
            console.log(e)
            this.form.orgCode = e
        },
        getPosition() {

            this.axios.get('/oa/sys/org/list').then((res) => {
                if (res.code == 0) {
                    this.positions = res.data
                }
                // console.log(res)
            }).catch((err) => {
                console.log(err)
            })
        },
        // 查询职位下拉列表数据
        getPositionList() {
            const data = {}
            this.axios.post('/sys/v2/user/position/listSelect', data).then((res) => {
                if (res.code == 0) {
                    this.positionList = res.data
                }
                // console.log(res)
            }).catch((err) => {
                console.log(err)
            })
        },
        // 部门选择列表
        department() {
            this.axios
                .post(
                    "/sys/v1/org/tree/select",
                    {
                        request: {
                            orgName: "",
                            orgType: "",
                        },
                        version: "",
                    },
                    {
                        headers: {
                            isLoading: false,
                        },
                    }
                )
                .then((res) => {
                    // console.log(res);
                    if (res.code == 0) {
                        this.options = res.data;
                    } else {
                        this.$message.error(res.message);
                    }
                });
        },

        handleClick(tab, event) {
            console.log(tab, event);
        },
        handleClickAchors(tab, event) {
            // console.log(tab, event);
            this.activeBtn = String(tab.index)
            let selector = 'anchor-' + String(tab.index)
            // console.log('>>',selector,this.$refs)
            this.$refs[selector].scrollIntoView({ behavior: 'smooth' })
            this.isGo = true
            setTimeout(() => {
                //点击滚动完成
                this.isGo = false
            }, 500);
        },
    }
}
</script>
  
<style scoped lang="scss">
/deep/.el-date-editor{
    width: 204px;
    .el-input__inner {
        padding-left: 8px;
    }
     .el-input__prefix {
        right: 2px;
        left: auto;
        
    }
     .el-icon-circle-close {
        // right: 16px !important;
        position: absolute;
        top: 1px;
        right: 16px;
    }
}


.container {
    width: 100%;
    height: 100%;

    .content {
        width: 100%;
        // min-height: calc(100vh - 110px);
        margin-top: 16px;
        background-color: white;
        padding-left: 0px;
        padding-right: 0px;
        box-sizing: border-box;
        border-radius: 8px 8px 0 0;

        .main1 {
            padding-top: 0;
            // height: calc(100vh - 225px);
            box-sizing: border-box;
            padding-left: 16px;
            padding-right: 16px;
            overflow-y: visible;
            .panel-block {
                // height: 100%;
                min-height: 100%;
                display: flex;

                .panel-left {
                    width: calc(100% - 225px);
                    overflow-y: auto;
                    height: 100%;

                    .panel-item {
                        .panel-item-title {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: bold;
                            font-size: 16px;
                            color: #2F3030;
                            padding-top: 32px;
                        }
                        .panel-item-title-1{
                            padding-top: 16px;
                        }

                        .panel-item-content {
                            padding-top: 24px;
                            border-top: 0;
                            height: auto;

                            .form-item {
                                display: flex;
                                // justify-content: space-between;
                                flex-wrap: wrap;
                                // min-width: 600px;
                                // max-width: 100%;
                            }

                            .el-form-item {
                                // width: 290px;
                                margin-right: 26px;
                                margin-bottom: 20px;
                            }

                            .line {
                                width: calc(100% - 58px);
                                height: 1px;
                                background: #EDF2F2;
                                border-radius: 0px 0px 0px 0px;
                                // margin-bottom: 32px;
                                margin-top: 32px;
                            }

                            .relative {
                                 width: calc(100% - 58px);
                                min-height: 67px;
                                padding: 18px 0 0 0;
                                background: #F8FAFA;
                                border-radius: 0px 0px 0px 0px;
                                display: flex;
                                justify-content: flex-start;
                                align-items: center;
                                flex-wrap: wrap;
                                /deep/.el-form-item{
                                    margin-bottom: 16px;
                                }
                                .main-colume{
                                    flex-shrink: 0;
                                    min-height: 32px;
                                    margin-right: -6px;
                                }
                                .primary-colume{
                                    // flex: 1;
                                    min-height: 32px;
                                }
                            }

                            .sort-index {
                                width: 16px;
                                height: 16px;
                                background: #E4F7F4;
                                line-height: 16px;
                                border-radius: 50%;
                                font-family: PingFang SC, PingFang SC;
                                font-weight: bold;
                                font-size: 12px;
                                color: #00B498;
                                text-align: center;
                            }

                            .sort-title {
                                font-family: PingFang SC, PingFang SC;
                                font-weight: bold;
                                font-size: 14px;
                                color: #2F3030;
                                margin-left: 2px;
                            }

                            .btn {
                                width: calc(100% - 58px);
                                height: 52px;
                                background: #FFFFFF;
                                border-radius: 0px 0px 0px 0px;
                                border: 1px solid #00B498;
                                box-sizing: border-box;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                margin-top: 10px;

                                .btn-t {
                                    font-family: PingFang SC, PingFang SC;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #00B498;
                                    margin-left: 2px;
                                    cursor: pointer;

                                }
                            }

                            .delete {
                                width: 44px;
                                height: calc(100% - 18px);
                                background: #E4F7F4;
                                border-radius: 0px 16px 16px 0px;
                                font-family: PingFang SC, PingFang SC;
                                font-weight: 400;
                                font-size: 14px;
                                color: #04B599;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                text-align: center;
                                position: absolute;
                                right: 16px;
                                box-sizing: border-box;
                                cursor: pointer;
                            }
                        }
                    }
                }

                .panel-right {
                    padding-top: 10px;
                    position: fixed;
                    left: calc(100% - 268px);
                    /deep/{
                        .vertical-tabs {
                            .el-tabs__active-bar{
                            width: 3px!important;
                            border-radius: 3px;
                            top: 4px;
                          }
                          .el-tabs__nav-wrap::after {
                            width: 1px;
                            left: 1px;
                          }
                        }
                    }
                    .step-line {
                        position: absolute;
                        left: 6px;
                        top: 0;
                        width: 1px;
                        background: #dcdfe6;
                        height: calc(50vh - 85px);
                        z-index: 0;
                    }

                    .step-ul {
                        li {
                            padding-bottom: 20px;

                            .step-icon {
                                width: 13px;
                                height: 13px;
                                margin-right: 20px;
                                border-radius: 50%;
                                z-index: 1;
                            }

                            .step-label {
                                font-weight: 700;
                                font-size: 14px;
                                line-height: 22px;
                                color: #303133;
                            }
                        }

                        .step-active {
                            .step-icon {
                                border: 1px solid #1989fe;
                                background: #fff;
                            }

                            .step-label {
                                color: #1989fe;
                            }
                        }
                    }
                }

                ::-webkit-scrollbar {
                    width: 0 !important;
                }
            }
        }

        .main2 {
            padding-top: 16px;
            height: calc(100vh - 180px);
            box-sizing: border-box;
            padding-left: 16px;
            padding-right: 16px;

            .title {
                font-family: PingFang SC, PingFang SC;
                font-weight: bold;
                font-size: 16px;
                color: #2F3030;
            }

            .main2-content {
                margin-top: 30px
            }
        }


    }

    .footer {
        height: 84px;
        background: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        left: 200px;
        right: 0;
        bottom: 0;
        border-top: 1px solid #EDF2F2;
        box-sizing: border-box;
      transition: left 0.3s ease-in-out ;
        z-index: 2;
        .footer-btn-b {
            width: 88px;
            height: 36px;
            background: #EDF2F2;
            border-radius: 4px 4px 4px 4px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #939696;
            line-height: 36px;
            text-align: center;
            margin-right: 16px;
            cursor: pointer;
        }

        .footer-btn-r {
            width: 88px;
            height: 36px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #00B498;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #00B498;
            line-height: 36px;
            text-align: center;
            margin-right: 16px;
            cursor: pointer;
        }

        .footer-btn-s {
            width: 88px;
            height: 36px;
            background: #00B498;
            border-radius: 4px 4px 4px 4px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 36px;
            text-align: center;
            cursor: pointer;
        }
    }
    .footer-collapsed{
        left: 80px;
    }

}

.title-line {
    width: 2px;
    height: 16px;
    background: #00B498;
    border-radius: 0px 0px 0px 0px;
    margin-top: 8px;
}

.title-name {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #2F3030;
    margin-left: 4px;
    line-height: 32px;
}

.dialog-body {
    .dialog-title {
        display: flex;
    }

    .dialog-line {
        width: 100%;
        height: 1px;
        background: #EDF2F2;
        border-radius: 0px 0px 0px 0px;
        margin-top: 10px;
    }

    .dialog-content {
        margin-top: 24px;

        .title-line {
            width: 2px;
            height: 16px;
            background: #00B498;
            border-radius: 0px 0px 0px 0px;
            margin-top: 8px;
        }

        .title-name {
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 16px;
            color: #2F3030;
            margin-left: 4px;
            line-height: 32px;
        }

        .dialog-main {
            .dialog-main-no {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #2F3030;
                text-align: center;
                margin-top: 38px;
                margin-bottom: 16px;
            }
        }
    }
}
.panel-item-content{

     /deep/  .el-textarea{
        .el-textarea__inner{
            padding-left: 8px;
            width:204px;
            height: 64px;
        }
        .el-input__count{
            line-height: 1;
            bottom: 6px;
        }
    }
    .dipute-textarea{
        margin-top: 1px;
        line-height: 32px;
        /deep/{
            .el-textarea__inner{
                height: 64px;
            }
            .el-input__count{
                line-height: 1;
                bottom: 6px;
                height: 18px;
            }
        }
    }
    .my-last-photo{
        display: inline-flex;
        .tips{
            margin-left: 8px;
            font-weight: 400;
            font-size: 12px;
            color: #C5C9C9;
            width: 108px;
            height:68px;
            line-height: 17px;
        }
        .img{
            width: 88px;
            height: 88px;
            object-fit: cover;
            cursor: pointer;
        }
    }
}
</style>